import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FilesState, filesAdapter } from './files.reducer';

export const selectFilesState = createFeatureSelector<FilesState>('files');

export const { selectEntities: selectFileEntities } = filesAdapter.getSelectors(selectFilesState);

export const selectFile = (fileId: number) =>
  createSelector(selectFileEntities, (entities) => entities[fileId] ?? null);
